import { forwardRef } from 'react'
import Dropdown from 'react-bootstrap/Dropdown'
import { DropdownItemProps } from 'react-bootstrap/DropdownItem'
import styled from 'styled-components/macro'

type ColumnOptionProps = DropdownItemProps & {
  prefixChildren?: JSX.Element
  suffixChildren?: JSX.Element
}

export const DropdownItemContainer = styled(Dropdown.Item)`
  padding: 0.75rem 0.5rem;
`

export const DropdownColumnItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`

export const DropdownItemText = styled.span`
  font-weight: 600;
  color: var(--bs-gray-800);
  font-size: 12px;
`

export const ColumnOption = forwardRef(
  (
    { prefixChildren, suffixChildren, children, ...props }: ColumnOptionProps,
    ref
  ) => (
    <DropdownItemContainer ref={ref} {...props}>
      <DropdownColumnItem>
        {prefixChildren}
        <DropdownItemText>{children}</DropdownItemText>
        {suffixChildren}
      </DropdownColumnItem>
    </DropdownItemContainer>
  )
)
ColumnOption.displayName = 'ColumnOption'

export const Wrapper = styled.div`
  position: relative;
  max-width: 200px;
  min-width: 200px;
`

export const Button = styled.button`
  color: #5a755e;
  display: flex;
  background-color: white;
  border: 1px solid #d0d5dd;
  border-radius: 6px;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  width: 100%;
  margin-right: 4px;
  font-size: 12px;
  height: 40px;

  & span {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #344054;

    & strong {
      font-weight: 500;
    }
  }
`

export const DropdownContainer = styled.div`
  max-width: 100%;
  min-width: 100%;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 50;
  background-color: white;
  border-radius: 6px;
  padding: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
`

export const OptionsScroll = styled.div`
  max-height: 500px;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 10px;
`
